import React from 'react'
import { Link } from 'react-router-dom'
import { PrimaryButton } from './Button'

const NotFound = ({ location }) => (
  <div className="pa3 mw9 center">
    <div className="br2 shadow-custom bg-white">
      <div className="tc pv6 ph4">
        <h3 className="f3 fw4">Cannot find “<span className="fw6">{location.pathname}</span>”</h3>
          <Link to="/">
            <PrimaryButton>Go to Home</PrimaryButton>
          </Link>
      </div>
    </div>
  </div>
)


export default NotFound



// WEBPACK FOOTER //
// ./src/components/NotFound.js